<template>
    <i :class="iconClass">
        <svg @mouseenter="mouseEnter" @mouseleave="mouseLeave" @click="emitEvent({ name: 'click', payload: $event })">
            <use :xlink:href="iconName" />
        </svg>
        <div
            v-show="(hintHeader || hintText) && isHovered"
            class="icon__tooltip"
            @mouseenter="mouseEnter"
            @mouseleave="mouseLeave"
        >
            <div>
                <b>{{ hintHeader }}</b>
                <p>{{ hintText }}</p>
            </div>
        </div>
    </i>
</template>

<script>
    export default {
        props: {
            name: { type: String, required: true },
            size: { type: String, required: true },
            hintHeader: { type: String, default: null },
            hintText: { type: String, default: null },
        },

        data() {
            return {
                isHovered: false,
            }
        },

        computed: {
            iconClass() {
                return {
                    icon: true,
                    [`icon--size-${this.size}`]: true,
                }
            },

            iconName() {
                return `#icon-${this.name}`
            },
        },

        methods: {
            mouseEnter() {
                this.isHovered = true
            },

            mouseLeave() {
                this.isHovered = false
            },
        },
    }
</script>
